import { Link } from "react-router-dom";
import { FiUser, FiTrendingUp, FiArrowDown, FiArrowUp } from "react-icons/fi";

export const QuickActionsBar = () => {
  const actions = [
    { label: "Profile", to: "/dashboard/account", icon: <FiUser size={20} /> },
    {
      label: "Invest",
      to: "/dashboard/plans",
      icon: <FiTrendingUp size={20} />,
    },
    {
      label: "Deposit",
      to: "/dashboard/fund",
      icon: <FiArrowDown size={20} />,
    },
    {
      label: "Withdraw",
      to: "/dashboard/withdraw",
      icon: <FiArrowUp size={20} />,
    },
  ];

  return (
    <div className="grid grid-cols-4 items-center justify-between gap-3 bg-white p-2 rounded-2xl border border-gray-100 shadow-sm">
      {actions.map((item, idx) => (
        <Link
          key={idx}
          to={item.to}
          className="flex-1 flex items-center border justify-center  py-3 rounded-xl  hover:bg-gray-50 transition-colors group"
        >
          <span className="text-gray-500 group-hover:text-gray-900 transition-colors">
            {item.icon}
          </span>
          <span className="text-[13px] font-bold text-gray-600 group-hover:text-gray-900">
            {item.label}
          </span>
        </Link>
      ))}
    </div>
  );
};
